import { render } from "./PurOrderDisplay.vue?vue&type=template&id=68a76374"
import script from "./PurOrderDisplay.vue?vue&type=script&lang=js"
export * from "./PurOrderDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__